// require("dotenv").config()

const Url = process.env.REACT_APP_API_URL;

// console.log(Url)

// console.log("Hello Env")

// console.log(process.env)

// console.log(process.env.REACT_APP_API_URL)

// console.log(process.env.REACT_APP_UPLOAD_DOCUMENT_SIZE_KB)

const SiteUrl = process.env.REACT_APP_SITE_URL;

const secretKey = process.env.REACT_APP_SECRET_KEY;

const themeDefault = process.env.REACT_APP_DEFAULT_THEME;

const namesOfModes = ["dark", "moonlight", "eclipse", "light"];

const poweredBy = process.env.REACT_APP_POWERED_BY;

const siteName = process.env.REACT_APP_SITE_NAME;

const toastIntervalSeconds = process.env.REACT_APP_TOAST_INTERVAL_SECONDS;

const toastNotificationIntervalSeconds =
  process.env.REACT_APP_TOAST_NOTIFICATION_INTERVAL_SECONDS;

const monitoringDashboardStatsSeconds =
  process.env.REACT_APP_MONITORING_DASHBOARD_INTERVAL_SECONDS;

const emergencyDashboardStatsSeconds =
  process.env.REACT_APP_EMERGENCY_DASHBOARD_INTERVAL_SECONDS;

const emergencyDashboardStatsSetTimeOutSeconds =
  process.env.REACT_APP_EMERGENCY_DASHBOARD_TIMEOUT_SECONDS;

const uploadPdfSizeKb = process.env.REACT_APP_UPLOAD_DOCUMENT_SIZE_KB;

const geoApiUrl = process.env.REACT_APP_GEO_API_URL;

const checkMccCertificate =
  process.env.REACT_APP_IS_CHECK_RTO_VERIFICATION_FOR_MCC_CERTIFICATE;

export {
  SiteUrl,
  secretKey,
  Url,
  themeDefault,
  namesOfModes,
  poweredBy,
  siteName,
  toastIntervalSeconds,
  toastNotificationIntervalSeconds,
  monitoringDashboardStatsSeconds,
  emergencyDashboardStatsSeconds,
  emergencyDashboardStatsSetTimeOutSeconds,
  uploadPdfSizeKb,
  geoApiUrl,
  checkMccCertificate,
};
